module.exports = __webpack_public_path__ + "static/img/dialog_3.73a648f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/anniversary/guide/dialog_3.png
// module id = ExhY
// module chunks = 4